import { createTRPCClient } from "@trpc/react";
import type { AppRouter } from "../pages/api/[trpc]";

export const API_URL = "/api";

export const api = createTRPCClient<AppRouter>({
  url: API_URL,
});
